// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"tooltip_tooltip__rwk8u","icon":"tooltip_icon__uFoYx"};